import { render, staticRenderFns } from "./ChainSelector.vue?vue&type=template&id=0ca9c449"
import script from "./ChainSelector.vue?vue&type=script&lang=js"
export * from "./ChainSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports